import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './branding.scss';

ReactDOM.render(<App />, document.getElementById('root'));
